import { postRequest } from '@/core';
import { goodsTypes } from '@/requests';

export default async function syncGoodsTypes() {
	let url = goodsTypes.getSyncPath();
	try {
		let response = await postRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}